module.exports = __webpack_public_path__ + "img/PlatformComposition_Zhongduan.f3e1a406.png";